import React, { useState, ChangeEvent } from 'react'
import { Button, LabeledTextarea } from '@apex/component-library'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
  Text,
} from '@chakra-ui/react'
import {
  TransferTypeRejectDto,
  TransferTypeRejectDtoDisplay,
} from '../../../../api/types'

const PositiveActionModal = ({
  isOpen,
  onClose,
  putCaseReject,
}: {
  isOpen: boolean
  onClose: () => void
  putCaseReject: ({
    comment,
    rejectReason,
  }: {
    comment: string
    rejectReason: string
  }) => void
}) => {
  const [comment, setComment] = useState('')
  const handleInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const inputValue = e.target.value
    setComment(inputValue)
  }
  const rejectReason = TransferTypeRejectDto.CreditPolicyViolated

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader mb={5}>Reject ACAT</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={6}>Please confirm you want to reject this case.</Text>
          <Text fontWeight="bold">Reason *</Text>
          <Text mb={5}>{TransferTypeRejectDtoDisplay[rejectReason]}</Text>
          <LabeledTextarea
            label="Comment *"
            fontWeight="bold"
            value={comment}
            onChange={handleInputChange}
          />
        </ModalBody>
        <ModalFooter>
          <Stack direction="row" spacing={2}>
            <Button variant="white" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="negative"
              onClick={() => {
                onClose()
                putCaseReject({ comment, rejectReason })
              }}
            >
              Reject
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default PositiveActionModal
